import React, { useEffect } from 'react';

// mui
import { Grid, styled } from '@mui/material';

// util
import { useNavigate } from 'react-router';
import WorkflowProgressView from '../WorkflowProgressView/WorkflowProgressView';

// styled components
const SessionBox = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  background: theme.palette.background.paper,
}));

const OuterItem = styled(Grid)({
  padding: '0px 8px 0px 8px',
});

function SelectedSessionBox({ selectedSession, refreshSessions }) {
  const navigate = useNavigate();

  useEffect(() => {
    // Update the URL params accordingly
    // depending on what session is selected
    const params = new URLSearchParams(window.location.search);
    params.set('viewSession', selectedSession.projectSessionId);
    navigate({ search: params.toString() });
  }, [selectedSession]);

  return (
    <OuterItem container>
      <Grid item xs={12}>
        <SessionBox container>
          <WorkflowProgressView
            isSplitView
            id={selectedSession.projectId}
            project_session_id={selectedSession.projectSessionId}
            isTest={Boolean(selectedSession.projectTestId)}
            refreshSessions={refreshSessions}
          />
        </SessionBox>
      </Grid>
    </OuterItem>
  );
}

export default SelectedSessionBox;
